import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RentHeader, { RentFooter } from "../rent/RentHeader";
import { lastBooking } from "../rent/api";
import { euro, fmtDate, fmtDateTime } from "../rent/tariffs";
import { Icons, weekdayRange } from "../rent/ui";
import "../login/login.css";

// Rückkehr von Stripe: /erfolg?session_id=…
const SuccessPage = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [query] = useSearchParams();
  const b = lastBooking();
  const ref = (query.get("session_id") || "").slice(-8).toUpperCase();

  useEffect(() => {
    document.title = "Bezahlt | innopark24";
  }, []);

  const lines = [];
  if (b) {
    lines.push([t("rxSite"), `${b.title} · ${b.code}`]);
    if (b.fee && b.entry) lines.push([t("pyEntry"), fmtDateTime(b.entry, lang)]);
    lines.push([t("rxTariff"), b.tariff]);
    if (b.monthly) {
      lines.push([t("rxStart"), fmtDate(b.start, lang, { year: "numeric" })]);
      if (b.weekdays) lines.push([t("rxWeekdays"), weekdayRange(b.weekdays, lang) || t("rxDaily")]);
    } else if (!b.fee || b.end) {
      lines.push([t("rxValid"), `${fmtDateTime(b.start, lang)} – ${fmtDateTime(b.end, lang)}`]);
    }
    lines.push([b.monthly ? t("rxMonthly") : t("rxPaid"), `${euro(b.total, lang)}${b.monthly ? ` ${t("rxPerMonthShort")}` : ""}`]);
  }
  if (ref) lines.push([t("rxReference"), ref]);

  return (
    <div className="rp">
      <RentHeader />
      <main className="rp-main">
        <div className="rx-card rx-done">
          <div className="rx-ok">{Icons.check}</div>
          <h1>{b && b.monthly ? t("rxDoneSubHead") : b && b.fee ? t("pyDoneHead") : t("rxDoneHead")}</h1>
          {b && b.email ? <p className="rx-muted">{t("rxDoneMail", { email: b.email })}</p> : !(b && b.fee) && <p className="rx-muted">{t("rxDoneMailGeneric")}</p>}
          {(b || ref) && (
            <div className="rx-ticket">
              {b && (
                <div className="rx-ticket-top">
                  <span className="rx-plate">
                    <i>D</i>
                    <em>{b.plate}</em>
                  </span>
                  <span className="rx-chip green">{b.fee ? t("pyPaidChip") : t("rxActive")}</span>
                </div>
              )}
              {lines.map(([k, v]) => (
                <div className="rx-line" key={k}>
                  <span>{k}</span>
                  <b>{v}</b>
                </div>
              ))}
            </div>
          )}
          <p className="rx-muted" style={{ fontSize: 15, marginBottom: 18 }}>
            {b && b.fee ? t("pyDoneText") : t("rxDoneCamera")}
          </p>
          {b && b.fee ? (
            <div className="rx-actions">
              <Link className="ipl-btn" to="/">
                <span>{t("rxBackStart")}</span>
              </Link>
            </div>
          ) : (
            <div className="rx-actions">
              <Link className="rx-btn-ghost" to="/">
                {t("rxBackStart")}
              </Link>
              <Link className="ipl-btn" to="/meine-buchungen">
                <span>{t("rxNavMy")}</span>
              </Link>
            </div>
          )}
        </div>
      </main>
      <RentFooter />
    </div>
  );
};

export default SuccessPage;
